import './emptySearch.scss'

const EmptySearch = ({searchText}: { searchText: string }) => {
    const text = [
        "Убедитесь, что все слова написаны правильно",
        "Попробуйте ввести другие поисковые запросы",
        "Попробуйте использовать более общие поисковые запросы"
    ]

    return <div className={'empty-search'}>
        <div className={'empty-title'}>К сожалению, мы не смогли ничего найти по запросу {searchText}</div>
        <div className={'empty-subtitle'}>Попробуйте оптимизировать ваш поиск. Вот несколько предложений:</div>
        <ul>
            {text.map(el => <li className={'empty-text'}>{el}</li>)}
        </ul>
    </div>
}

export default EmptySearch